import styled, { keyframes } from 'styled-components'

const WrapperWindowOpen = keyframes`
  0% {
    background-color: transparent;
  }

  100% {
    background-color: rgb(22 22 22 / 50%);
  }
`

const WrapperWindowClose = keyframes`
  0% {
    background-color: rgb(22 22 22 / 50%);
  }
  
  100% {
    background-color: transparent;
  }
`

const windowOpen = keyframes`
  0% {
    transform: translate(-50%, -300%);
    opacity: 0;
    
  }
  50%{
    opacity: 1;
  }

  100% {
    transform: translate(-50%, -50%);
    opacity: 1;
  }
`

const windowClose = keyframes`
  0% {
    transform: translate(-50%, -50%);
    opacity: 1;
  }
  50%{
    opacity: 0;
  }

  100% {
    transform: translate(-50%, -300%);
    opacity: 0;
  }
`

export const WrapperWindow = styled.div<{
  open: boolean
  displayState: boolean
  isFixed?: boolean
  zIndex?: number
}>`
  width: 100%;
  height: 100vh;
  position: ${({ isFixed }) => (isFixed ? 'fixed' : 'absolute')};
  left: 0;
  top: 0;
  display: ${({ displayState }) => (displayState ? 'block' : 'none')};
  animation: ${({ open }) => (open ? WrapperWindowOpen : WrapperWindowClose)} forwards;
  animation-duration: 0.5s;
  background-color: ${({ open }) =>
          open ? ' transparent ' : 'rgb(22 22 22 / 50%)'};
  z-index: ${({ zIndex }) => (zIndex ?? 99)};

  & > div {
    position: absolute;
    top: 50%;
    left: 50%;
    opacity: ${({ open }) => (open ? 0 : 1)};
    animation: ${({ open }) => (open ? windowOpen : windowClose)} forwards;
    transform: ${({ open }) =>
            open ? 'translate(-50%, -300%)' : 'translate(-50%, -50%)'};
    animation-duration: 0.3s;
    animation-delay: 0.1s;
  }
`
